import {
  USER_FRUI_QPBZ_MODAL_CHANGE,
} from './constants';

export function frui_qpbzModalChange(visible,type) {
  return {
    type: USER_FRUI_QPBZ_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_FRUI_QPBZ_MODAL_CHANGE:
      return {
        ...state,
        frui_qpbzModalType:action.data.type,
        frui_qpbzModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/frui_qpbzModalChange.js